import React from 'react'
import PropTypes from 'prop-types'
import { StyledFooterP } from './atoms'
import { ApplePay } from 'portal-modules/common/svgs'
import {
  PAYMENT_TYPES,
  PAYMENT_TYPES_BY_ID,
} from 'portal-modules/payments/constants/types'
import styled from '@emotion/styled'
import { getEmbeddedViewFlag } from 'portal-modules/common/utils/get-embedded-flag'

const StyledConfirmedTextSpan = styled('span')`
  color: ${({ theme }) => theme.success.base};
`

const StyledPendingTextSpan = styled('span')`
  color: ${({ theme }) => theme.error.base};
`

const StyledCardDetail = styled('span')`
  font-size: 13px;
  font-weight: 600;
  flex: 1;
  color: ${({ is_on_hold, theme }) => getEmbeddedViewFlag() ? theme.secondary.base :
    is_on_hold ? theme.error.base : 'inherit'};
`

const StyledApplePayCardDetail = styled(StyledCardDetail)`
  display: flex;
  align-items: center;
  gap: 8px;
`


const StyledSpan = styled('span')`
  font-size: 11.5px;
  font-weight: 100;
`

const FooterCardDetails = ({
  is_card,
  card_info,
  bank_info,
  sepa_info,
  payment_type_id,
  needs_terms_approval,
  wallet_info,
}) => {
  if (wallet_info && wallet_info.masked_card_number) {
    const last4 = wallet_info.masked_card_number.slice(-4)
    return (
      <StyledApplePayCardDetail is_on_hold={needs_terms_approval}>
        <ApplePay size='28px'/>
        <span>•••• {last4}</span>
        {needs_terms_approval && (
          <StyledSpan>{__('Auto-Payment on hold')}</StyledSpan>
        )}
      </StyledApplePayCardDetail>
    )
  }

  const cardType =
    payment_type_id != PAYMENT_TYPES.CARD.value
      ? PAYMENT_TYPES[PAYMENT_TYPES_BY_ID[payment_type_id]]?.getName()
      : card_info?.card_type_id
        ? PAYMENT_TYPES[PAYMENT_TYPES_BY_ID[card_info?.card_type_id]]?.getName()
        : PAYMENT_TYPES[PAYMENT_TYPES_BY_ID[payment_type_id]]?.getName()
  const maskedNumber = sepa_info
    ? sepa_info.iban
    : is_card
    ? card_info.masked_card_number
    : bank_info && bank_info.account_number_masked

  return maskedNumber ? (
    <StyledCardDetail is_on_hold={needs_terms_approval}>
      {cardType == 'SEPA' ? 'SEPA Direct Debit' : cardType}
      {maskedNumber.substr(-4)} <br />
      {needs_terms_approval && (
        <StyledSpan>{__('Auto-Payment on hold')}</StyledSpan>
      )}
    </StyledCardDetail>
  ) : null
}

FooterCardDetails.propTypes = {
  is_card: PropTypes.bool,
  card_info: PropTypes.object,
  bank_info: PropTypes.object,
  sepa_info: PropTypes.object,
  needs_terms_approval: PropTypes.bool,
  payment_type_id: PropTypes.number,
}

const UnapprovedSpliPaymentCount = ({ roommate_payments, is_approved }) => {
  let paymentCount = roommate_payments?.length
  let approvedPaymentCount =
    roommate_payments &&
    roommate_payments.filter(payment => payment.is_approved)?.length
  return approvedPaymentCount == paymentCount ? (
    <StyledConfirmedTextSpan>
      {__('Confirmed {%s, 0} / {%d, 1}', [approvedPaymentCount, paymentCount])}
    </StyledConfirmedTextSpan>
  ) : (
    <StyledPendingTextSpan>
      {__('Pending {%s, 0} / {%d, 1} ', [
        paymentCount - approvedPaymentCount,
        paymentCount,
      ])}
    </StyledPendingTextSpan>
  )
}

UnapprovedSpliPaymentCount.propTypes = {
  roommate_payments: PropTypes.array,
  is_approved: PropTypes.bool,
}

export const AutoPayment = props => (
  <StyledFooterP>
    <FooterCardDetails {...props} />
  </StyledFooterP>
)

export const BiMonthly = props => (
  <StyledFooterP>
    <FooterCardDetails {...props} />
  </StyledFooterP>
)

export const Split = ({ ...props }) => (
  <StyledFooterP showCardDetails={!!(props.is_card || props.bank_info)} type={props.type}>
    <FooterCardDetails {...props} />
    <UnapprovedSpliPaymentCount {...props} />
  </StyledFooterP>
)

Split.propTypes = {
  bank_info: PropTypes.object,
  is_card: PropTypes.bool,
}
